import { omit } from 'lodash'

const formatFerryOptions = (options = {}) => {
  const groupedRoutes = options?.routes?.reduce((obj, route) => {
    const currentRouteData = obj[route?.ferryId] || {}
    const currentCrossings = currentRouteData?.crossings || []

    route?.crossings?.forEach(crossing => {
      if (
        !currentCrossings.some(
          ({ supplierCode }) => supplierCode === crossing.supplierCode,
        )
      ) {
        const additionalData =
          options?.routes?.find(({ code }) => code === crossing.supplierCode) ||
          {}

        currentCrossings.push({
          ...omit(additionalData, ['crossings']),
          ...crossing,
          id: crossing.supplierCode,
        })
      }
    })

    return {
      ...obj,
      [route?.ferryId]: currentCrossings,
    }
  }, {})

  return { ...options, routes: groupedRoutes }
}
const reduceConfiguration = res => {
  const data = res?.data?.['hydra:member']
  if (data) {
    return data.reduce((obj, config) => {
      const { id, options, labels } = config

      const formattedOptions =
        id === 'ferry' ? formatFerryOptions(options) : options

      return {
        ...obj,
        [id]: {
          options: formattedOptions,
          labels: labels[0],
        },
      }
    }, {})
  }
  return null
}

export default reduceConfiguration
